import { render } from "./SmDetailLayout.vue?vue&type=template&id=33f7d6e8&scoped=true"
import script from "./SmDetailLayout.vue?vue&type=script&lang=js"
export * from "./SmDetailLayout.vue?vue&type=script&lang=js"

import "./SmDetailLayout.vue?vue&type=style&index=0&id=33f7d6e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f7d6e8"]])

export default __exports__